<template>
    <v-dialog
        v-model="qteDialog"
        width="700"
        scrollable
    >
        <!-- <v-container > -->
            <v-card>
                <v-card-title class="text-h5">
                    Consultation des compteurs
                </v-card-title>
                
                <v-card-text>
                    <!-- Sélection du magasin -->
                    <v-row>
                        <v-col cols="5">
                            <v-combobox 
                                label="Sélectionnez un magasin"
                                v-model="selectedStoreId"
                                :items="props.storeOptions"
                                variant="outlined"
                                density="compact"
                                clearable
                                @update:model-value="updateDisplayedQuantities"
                            ></v-combobox>
                        </v-col>
                    </v-row>
                    
                    <!-- Tableau des quantités -->
                    <v-data-table
                    v-if="displayedQuantities.length > 0"
                    :headers="headers"
                    :items="displayedQuantities"
                    :items-per-page="-1"
                    hide-default-footer
                    class="elevation-1"
                    density="compact"
                    >
                    <template #item.label="{ item }">
                        <v-chip
                        size="small"
                        @click="selectedQuantityPrime=item.label"
                        >
                        {{ quantityLabels[item.label].libelle }}
                        </v-chip>
                      
                    </template>
                    <template #item.type="{ item }">
                        <v-icon v-if="item.type!=''&&item.type!='package'"  :color="item.type=='plus'&&item.quantity>0?'green':'red'" :icon="`mdi-checkbox-marked-circle-${item.type=='plus'&&item.quantity>0?'plus':'minus'}-outline`"></v-icon>
                        <v-icon v-if="item.type=='package'" :color="`${item.quantity>=0?'blue':'red'}`" :icon="`${item.quantity>=0?'mdi-package-variant-closed':'mdi-package-variant-minus'}`"></v-icon>
                        <v-chip size="x-small" class="dimension-vatican" v-if="item.label=='transferRequestQuantity'&&crossDock" color="blue" > Cross Dock</v-chip>
                        
                        <!-- <v-chip v-if="">{{  }}</v-chip> -->
                    </template>
                    <!-- :color="getQuantityColor(item.quantity)" -->
                    <template #item.quantity="{ item }">
                        <v-chip
                        :color="getQuantityColor(item.quantity)"
                        size="small"
                        >
                        {{ item.type=='package'?item.quantity:Math.abs(item.quantity) }}
                        </v-chip>
                    </template>
                    <template #item.check="{ item }">
                        <input type="checkbox" v-model="item.check">
                    </template>
                    </v-data-table>

                    <!-- Message quand aucune donnée -->
                    <v-alert
                    v-else-if="!selectedStoreId"
                    type="info"
                    variant="tonal"
                    class="mt-4"
                    >
                    Veuillez sélectionner un magasin pour afficher les quantités.
                    </v-alert>

                    <v-alert
                    v-else-if="selectedStoreId && displayedQuantities.length === 0"
                    type="warning"
                    variant="tonal"
                    class="mt-4"
                    >
                    Aucune quantité disponible pour ce magasin.
                    </v-alert>
                <!-- </v-card-text>
                <v-card-text> -->
                    
                    <PieQuantities 
                    v-if="['DEPO','NEGO','NGEXT','LO07'].includes(selectedStoreId)"
                    :data="props.productData"
                    :quantityLabels
                    :selectedQuantityPrime
                    :selectedStore="selectedStoreId"
                    ></PieQuantities>
                    <TauxRevente
                    :p_saison="'H26'"
                    :p_code_article="props.productData.id"
                    :p_codeabarre="props.productData.barcode"
                    ></TauxRevente>
                </v-card-text>

                    
                <v-card-actions class="py-1">
                    <v-spacer />
                    <v-btn variant="text"  @click="qteDialog = false" color="red">Fermer</v-btn>
                </v-card-actions>
                
            </v-card>
            
        <!-- </v-container> -->
  </v-dialog>
</template>

<script setup>
    import { ref, watch,computed , onMounted } from 'vue'
    import PieQuantities from './PieQuantities.vue'
    import TauxRevente from './TauxRevente.vue'
    import store from '../store'
    const qteDialog = defineModel()
    const props = defineProps({
      productData:{
        type: Object,
        required: true
      },
      storeOptions:{
        type: Array,
        required: true
      }
    })
    // États
    const selectedStoreId = ref(store.state.etablissement)
    const displayedQuantities = ref([])
    let selectedQuantityPrime=ref('frontOfficeSalesQuantity')
    // Traductions
    const quantityLabels = {
        customerAvailableQuantity: { libelle: 'Qté disponible client', type: '' },
        customerCreditQuantity: { libelle: 'Qté crédit client', type: '' },
        customerDeliveryQuantity: { libelle: 'Qté livraison client', type: 'minus' },
        customerDeliveryPreparationQuantity: { libelle: 'Qté préparation livraison', type: '' },
        customerInvoiceQuantity: { libelle: 'Qté facture client', type: 'minus' },
        customerOrderQuantity: { libelle: 'Qté commande client', type: '' },
        customerReservationRequestQuantity: { libelle: 'Qté demande réservation', type: '' },
        deliveryNoticeQuantity: { libelle: 'Qté annonce de livraison', type: '' },
        frontOfficeSalesQuantity: { libelle: 'Qté ventes front office', type: 'minus' },
        initialInventoryQuantity: { libelle: 'Qté inventaire initial', type: 'plus' },
        inventoryDiscrepancyQuantity: { libelle: 'Écart d\'inventaire', type: 'plus' },
        orliPreparationQuantity: { libelle: 'Qté préparation ORLI', type: '' },
        outOfStockQuantity: { libelle: 'Rupture de stock', type: '' },
        physicalQuantity: { libelle: 'Qté physique', type: 'package' },
        specialInputDraftQuantity: { libelle: 'Qté entrée spéciale brouillon', type: '' },
        specialInputOutputQuantity: { libelle: 'Qté entrée/sortie spéciale', type: 'plus' },
        specialOutputDraftQuantity: { libelle: 'Qté sortie spéciale brouillon', type: 'minus' },
        supplierCreditQuantity: { libelle: 'Qté crédit fournisseur', type: 'plus' },
        supplierDeliveryQuantity: { libelle: 'Qté réception fournisseur', type: 'plus' },
        supplierInvoiceQuantity: { libelle: 'Qté facture fournisseur', type: '' },
        supplierOrderQuantity: { libelle: 'Qté commande fournisseur', type: '' },
        supplierPurchaseProposalQuantity: { libelle: 'Qté proposition achat', type: '' },
        supplierReturnDraftQuantity: { libelle: 'Qté retour fournisseur brouillon', type: 'minus' },
        supplierReturnQuantity: { libelle: 'Qté retour fournisseur', type: 'minus' },
        transferDraftQuantity: { libelle: 'Qté transfert brouillon', type: 'minus' },
        transferNoticeQuantity: { libelle: 'Qté avis de transfert', type: '' },
        transferQuantity: { libelle: 'Qté transfert', type: 'plus' },
        transferRequestQuantity: { libelle: 'Qté demande transfert', type: '' },
        webCartQuantity: { libelle: 'Qté panier web', type: '' }
    };
    let sommeCheckee = computed(() => {
        return displayedQuantities.value
            .filter(item => item.check === true && item.type !== '')
            .reduce((total, item) => {
                const quantite = Math.abs(item.quantity) // Valeur absolue
                if (item.type === 'plus') {
                    return total + quantite
                } else if (item.type === 'minus') {
                    return total - quantite
                }
                return total // Si type inconnu, on ne fait rien
            }, 0)
    })
    // En-têtes
    const headers = [
    { title: 'Type de quantité', key: 'label', sortable: true, align: 'center' },
    { title: 'Type Mvt', key: 'type', sortable: true, align: 'center' },
    { title: 'Valeur', key: 'quantity', sortable: true, align: 'center' },
    { title: sommeCheckee, key: 'check', align: 'center' }
    ]

    let crossDock=ref(false)
    const updateDisplayedQuantities = () => {
        if (!props.productData || !selectedStoreId.value) {
            displayedQuantities.value = []
            return
        }

        const stores = props.productData.stores.find(s => s.id === selectedStoreId.value)
        if (!stores?.warehouses?.length) {
            displayedQuantities.value = []
            return
        }

        const warehouse = stores.warehouses[0]
        if (!warehouse?.quantities) {
            displayedQuantities.value = []
            return
        }

        displayedQuantities.value = Object.entries(warehouse.quantities)
            .filter(([_, value]) => value !== 0)
            .map(([key, value]) => ({
            label: key,
            type: quantityLabels[key].type,
            quantity: value,
            check : false,
            key: key
            }))
            .sort((a, b) => a.label.localeCompare(b.label))
            crossDock.value=displayedQuantities.value.filter(item => {return item.label == 'deliveryNoticeQuantity'}).length>0?true:false
            
    }
    
    // console.log(displayedQuantities.value);
    

    const getQuantityColor = (value) => {
    if (value > 0) return 'success'
    if (value < 0) return 'error'
    return 'grey'
    }

    // Watchers
    
    watch(selectedStoreId, updateDisplayedQuantities)
    onMounted(()=>{
        // console.log(props.productData);
        updateDisplayedQuantities()
    })
</script>

<style scoped>
.v-card {
  margin: 20px;
}

.v-data-table {
  margin-top: 16px;
}

.v-chip {
  font-weight: 500;
  min-width: 60px;
  justify-content: center;
}

:deep(.v-data-table-header th) {
  background-color: #f5f5f5 !important;
  font-weight: bold !important;
}
.dimension-vatican {
    font-family: 'Times New Roman', 'Georgia', serif;
    font-style: italic;
    
}

</style>